// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_LIST,
  MEAL_ADD,
  MEAL_UPDATE,
  MEAL_DELETE,
  CATEGORY_LIST,
  CATEGORY_ADD,
  CATEGORY_UPDATE,
  CATEGORY_DELETE,
  CATEGORY_SUB,
  STAFF_ADD,
} from "../../config/constants"; // Adjust endpoints as per your config

const categoryService = createApi({
  reducerPath: "categoryService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Category", "SubCategory"],
  endpoints: (builder) => ({
    getCategory: builder.query({
      query: (bodyData) => ({
        url: CATEGORY_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Category"],
    }),
    getSubCategory: builder.query({
      query: (bodyData) => ({
        url: CATEGORY_SUB, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["SubCategory"],
      invalidatesTags: ["Category"],
    }),
    addCategory: builder.mutation({
      query: (mealData) => ({
        url: CATEGORY_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Category", "SubCategory"],
    }),

    addStaff: builder.mutation({
      query: (mealData) => ({
        url: STAFF_ADD, // Endpoint to add a staff
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Category"],
    }),

    updateCategory: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${CATEGORY_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Category", "SubCategory"],
    }),
    deleteCategory: builder.mutation({
      query: (mealId) => ({
        url: `${CATEGORY_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Category", "SubCategory"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCategoryQuery,
  useGetSubCategoryQuery,
  useLazyGetSubCategoryQuery,
  useAddCategoryMutation,
  useAddStaffMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryService;

// Export the reducer to be included in the store
export default categoryService;
